import { get } from 'store/http/httpAction';
import { SET_DATA, SET_FETCH_STATUS } from './actionTypes';

const setData = data => ({
  type: SET_DATA,
  payload: { data }
});

export const tryFetchFieldsMetaDataIfNeeded = () => dispatch => {
  return get('/admin/metadata/', {}, dispatch).then(data => {
    dispatch(setData(data));
  });
};

export const setFetchStatus = nextStatus => ({
  type: SET_FETCH_STATUS,
  payload: { isFetched: nextStatus }
});



// WEBPACK FOOTER //
// ./src/store/metaData/fields/actions.js